import { getWithList, getmaxTipPossible } from '../../cred';
import { decimalTrimmer } from '../../customLib';

export const initialWithList = {
	p2BankWithList: [],
	suggestedP2pBankWithTip: 0,
};

const getP2pBankWithList = async () => {
	try {
		const { status, data } = await getWithList();
		const { status: st, data: maxTip } = await getmaxTipPossible();

		if (status === 1) {
			return {
				p2BankWithList: data,
				suggestedP2pBankWithTip:
					st === 1
						? maxTip
						: data.length > 0
						? decimalTrimmer(Number(data[0].tip) * 100 + 1) / 100
						: 0,
			};
		}
	} catch (error) {
		console.log('getWithList', error);
	}
	return {};
};

export const getP2pBankWithListActions = {
	__getP2pBankWithList: getP2pBankWithList,
};
